import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useCallback,
  useContext,
  useState
} from 'react'

interface HeaderProps {
  currentStep: number
  totalSteps: []
  setCurrentStep?: Dispatch<SetStateAction<number>>
  setTotalSteps?: Dispatch<SetStateAction<any>>
  resetTotalSteps?: () => void
}

export const HeaderContext = createContext<HeaderProps>({
  currentStep: 1,
  totalSteps: []
})

interface Props {
  children?: ReactNode
}

const HeaderContextProvider = ({ children }: Props) => {
  const [currentStep, setCurrentStep] = useState<number>(1)
  const [totalSteps, setTotalSteps] = useState<[]>([])

  const resetTotalSteps = useCallback((): void => setTotalSteps([]), [])

  return (
    <HeaderContext.Provider
      value={{
        currentStep,
        totalSteps,
        setCurrentStep,
        setTotalSteps,
        resetTotalSteps
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}

export const useHeaderContext = () => useContext(HeaderContext)

export default HeaderContextProvider
